import { USER_VARIABLE, axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { UserVarValueType } from '@nx-frontend/shared/types';

interface ClientSetUserVarsParams {
  key: USER_VARIABLE | string;
  value: UserVarValueType;
  userId: number;
}

export async function clientSetUserVars({ key, value, userId }: ClientSetUserVarsParams) {
  await axiosClient.post(
    `${generalEnv.nextApiPath}/users/vars/${key}`,
    {
      value,
    },
    { userId }
  );
}
